import { render, staticRenderFns } from "./alarmData.vue?vue&type=template&id=a5072240&scoped=true"
import script from "./alarmData.vue?vue&type=script&lang=js"
export * from "./alarmData.vue?vue&type=script&lang=js"
import style0 from "./alarmData.vue?vue&type=style&index=0&id=a5072240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5072240",
  null
  
)

export default component.exports